import React, { useEffect, useState } from "react";
import { Button, Card, Input, Space, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import authService from "services/authService";
import RouteEnum from "constants/RouteEnum";

const VerifyPasswordReset = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(60);
  const [challengeId, setChallengeId] = useState(
    sessionStorage.getItem("passwordResetChallenge")
  );

  useEffect(() => {
    if (!challengeId) navigate(RouteEnum.ForgotPassword, { replace: true });
  }, [challengeId, navigate]);

  useEffect(() => {
    if (!cooldown) return undefined;
    const timer = window.setInterval(
      () => setCooldown((value) => Math.max(0, value - 1)),
      1000
    );
    return () => window.clearInterval(timer);
  }, [cooldown]);

  const verify = async () => {
    setLoading(true);
    try {
      const result = await authService.verifyPasswordOtp({
        challenge_id: challengeId,
        otp,
      });
      sessionStorage.removeItem("passwordResetChallenge");
      sessionStorage.setItem("passwordResetToken", result.reset_token);
      navigate(RouteEnum.ResetPassword);
    } catch {
      notification.error({ message: t("invalidOrExpiredCode") });
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    const email = sessionStorage.getItem("passwordResetEmail");
    setLoading(true);
    try {
      const result = await authService.forgotPassword(email, challengeId);
      sessionStorage.setItem("passwordResetChallenge", result.challenge_id);
      setChallengeId(result.challenge_id);
      setCooldown(60);
      setOtp("");
    } catch {
      notification.error({ message: t("resendUnavailable") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-layout d-flex align-items-center justify-content-center">
      <Card title={t("verifyCode")} style={{ width: 440, maxWidth: "94%" }}>
        <Input
          value={otp}
          maxLength={6}
          inputMode="numeric"
          autoComplete="one-time-code"
          onChange={(event) => setOtp(event.target.value.replace(/\D/g, ""))}
        />
        <Space className="mt-3">
          <Button type="primary" onClick={verify} loading={loading} disabled={otp.length !== 6}>
            {t("verifyAndProceed")}
          </Button>
          <Button onClick={resend} disabled={cooldown > 0 || loading}>
            {cooldown ? `${t("resendOTP")} (${cooldown})` : t("resendOTP")}
          </Button>
        </Space>
      </Card>
    </div>
  );
};

export default VerifyPasswordReset;
